import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export default function RequireRole({ allowedRoles, children }) {
  const { user } = useAuth();
  if (!allowedRoles.includes(user?.doctorType)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export function RequireNotStaff({ children }) {
  const { isStaff } = useAuth();
  if (isStaff) {
    return <Navigate to="/" replace />;
  }
  return children;
}
